import {
  RECORD_LOAD,
  RECORD_LOAD_SUCCESS,
  RECORDED_DELETE,
  RECORDED_ADD,
  RECORDED_REMOVE,
  RECORDED_REFRESH,
  RECORD_ACTION_SUCCESS,
  RECORD_ACTION_ERROR,
  RECORDED_GET,
  RECORDED_GET_SUCCESS,
  RECORDED_GET_CLEAR,
  RECORDED_EPG_GET,
  RECORD_ACTION_ERROR_CLEAR
} from "./actions";
import {
  GUIDE_LOAD_SUCCESS,
  STREAM_LOAD_CHANNEL_SUCCESS,
  SPORTS_DETAIL_LOAD_SUCCESS
} from "../../redux-root/actions";

const initialState = {
  planData: null,
  recordData: null,
  recordAction: true,
  actionError: false,
  timeSlotData: null,
  selectedEpg: null,
  errorMsg: null
};

export function recordReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case RECORD_LOAD:
      return {
        ...state,
        planData: null,
        recordData: null
      };

    case RECORD_LOAD_SUCCESS:
      return {
        ...state,
        planData: data.plan,
        recordData: data.recordData
      };

    case RECORDED_DELETE:
    case RECORDED_ADD:
    case RECORDED_REMOVE:
    case RECORDED_REMOVE:
      return {
        ...state,
        recordAction: false,
        actionError: false,
        errorMsg: null
      };

    case RECORD_ACTION_SUCCESS:
      return {
        ...state,
        recordData: data,
        recordAction: true
      };

    case RECORD_ACTION_ERROR:
      return {
        ...state,
        recordAction: true,
        actionError: true,
        errorMsg: data
      };

    case GUIDE_LOAD_SUCCESS:
    case SPORTS_DETAIL_LOAD_SUCCESS:
      return {
        ...state,
        planData: action.plan,
        recordData: action.recorded
      };

    case STREAM_LOAD_CHANNEL_SUCCESS:
      return {
        ...state,
        planData: action.plan
      };

    case RECORDED_GET:
    case RECORDED_GET_CLEAR:
      return {
        ...state,
        timeSlotData: null,
        errorMsg: null
      };

    case RECORDED_EPG_GET:
      return {
        ...state,
        selectedEpg: null
      };

    case RECORDED_GET_SUCCESS:
      let newState = {
        timeSlotData: data,
        recordData: action.recorded
      };

      if (action.epg) {
        newState.selectedEpg = action.epg;
      }

      return {
        ...state,
        ...newState
      };

    case RECORD_ACTION_ERROR_CLEAR:
        return {
          ...state,
          errorMsg: null
        };

    default:
      return state;
  }
}
